import { render, staticRenderFns } from "./order-properties-update.vue?vue&type=template&id=024ea6a4&scoped=true"
import script from "./order-properties-update.vue?vue&type=script&lang=js"
export * from "./order-properties-update.vue?vue&type=script&lang=js"
import style0 from "./order-properties-update.vue?vue&type=style&index=0&id=024ea6a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ea6a4",
  null
  
)

export default component.exports